// extracted by mini-css-extract-plugin
export default {"container":"headerCard_container__HXUve","buttonWrapper":"headerCard_buttonWrapper__BVMWZ","divider":"headerCard_divider__vgSFI"};